import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const receivedRfqSlice = createSlice({
  name: "receivedRfq",

  initialState: {
    receivedRfqData: [],
    isError2: false,
  },

  reducers: {
    fetchRfqSuccess: (state, action) => {
      state.isError2 = false;
      state.receivedRfqData = action.payload;
    },
    fetchRfqFail: (state) => {
      state.isError2 = true;
    },
    resetState: (state) => {
      state.receivedRfqData = [];
      state.isError2 = false;
    },
  },
});

export const { fetchRfqSuccess, fetchRfqFail, resetState } =
  receivedRfqSlice.actions;

export const fetchReceivedRfq = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${config.apiUrl}/seller/product-enquiry`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      }
    );
    dispatch(fetchRfqSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchRfqFail());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};
export default receivedRfqSlice.reducer;
